import React, { Suspense, lazy, useEffect } from "react";
import Sidebar from "../../Module/sidebar";
import {
  InfraManagerEmpPanelSidebarData,
  InfraManagerPanelSidebarData,
} from "../../Module/infraManagerPanelSidebarData";
import Loading from "../../Component/Loading";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Logout, setInitialState } from "../../Action/authAction";
import { showSuccessSnackbar } from "../../Action/snackbarAction";

const AddAsset = lazy(() => import("./Asset/addAsset"));
const GetAsset = lazy(() => import("./Asset/getAsset"));
const AddInventoryManagement = lazy(() =>
  import("./InventoryManagement/addInventoryManagement")
);
const EditInventoryManagement = lazy(() =>
  import("./InventoryManagement/editInventoryManagement")
);
const CreateDeviceCompany = lazy(() =>
  import("./DeviceCompany/createDeviceCompany")
);
const EditDeviceCompany = lazy(() =>
  import("./DeviceCompany/editDeviceCompany")
);
const CreateDeviceModel = lazy(() => import("./DeviceModel/createDeviceModel"));
const EditDeviceModel = lazy(() => import("./DeviceModel/editDeviceModel"));
const MovementsOfMeeting = React.lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/movementsOfMeeting")
);
const EditMovementsOfMeeting = React.lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/editMovementsOfMeeting")
);

const DeviceDetail = React.lazy(() => import("./deviceDetail"));

const InfraManagerPanelDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginType, role, authToken } = useSelector((state) => ({
    designation: state.Auth?.userInfo?.designation,
    loginType: state.Auth?.loginType,
    role: state?.Auth?.userInfo?.role,
    authToken: state?.Auth?.authToken,
  }));

  useEffect(() => {
    if (!(role === "INFRAMANAGER" && authToken)) {
      dispatch(setInitialState());
      navigate("/");
    }
  }, [role, dispatch, Navigate, authToken]);
  return (
    <div className="AppBox">
      <Sidebar
        data={
          loginType === 2
            ? InfraManagerEmpPanelSidebarData
            : InfraManagerPanelSidebarData
        }
      />
      <div className="dashboard">
        {
          <Suspense
            fallback={
              <div className="border p-1">
                <Loading />
              </div>
            }
          >
            <Routes>
              <Route path="/" element={<AddAsset />} />
              <Route path="/addAsset" element={<AddAsset />} />
              <Route path="/getAsset" element={<GetAsset />} />
              <Route
                path="/addInventory"
                element={<AddInventoryManagement />}
              />
              <Route
                path="/editInventory"
                element={<EditInventoryManagement />}
              />
              <Route
                path="/createDeviceCompany"
                element={<CreateDeviceCompany />}
              />
              <Route
                path="/editDeviceCompany"
                element={<EditDeviceCompany />}
              />
              <Route
                path="/createDeviceModel"
                element={<CreateDeviceModel />}
              />
              <Route path="/editDeviceModel" element={<EditDeviceModel />} />
              <Route
                path="movementsOfMeeting"
                element={<MovementsOfMeeting />}
              />
              <Route
                path="editMovementsOfMeeting"
                element={<EditMovementsOfMeeting />}
              />
              <Route path="deviceDetail" element={<DeviceDetail />} />
            </Routes>
          </Suspense>
        }
      </div>
    </div>
  );
};

export default InfraManagerPanelDashboard;
